import React, { useState } from 'react';
import DataCollectionAdd from '../../shared/DataCollectionAdd.js';
import AreaDropdown from '../../shared/dropdowns/AreaDropdown.js';
import TagNumberInput from '../../shared/inputs/TagNumberInput.js';
import DamNumberInput from '../../shared/inputs/DamNumberInput.js';
import SexDropdown from '../../shared/dropdowns/SexDropdown.js';
import BreedDropdown from '../../shared/dropdowns/BreedDropdown.js';
import DateInput from '../../shared/inputs/DateInput.js';
import { HerdLotDropdown } from '../lots/HerdLotDropdown.js';
import { useTranslation } from 'react-i18next';

const today = () => new Date().toISOString().substring(0, 10);

const AddBirthForm = (props) => {
  const { t } = useTranslation();
  const [birthDate, setBirthDate] = useState('');
  const [registrationDate, setRegistrationDate] = useState(today);
  const [showLotPicker, setShowLotPicker] = useState(false);
  const [lotId, setLotId] = useState('');

  return (
    <>
      <div className="form-guidance">
        {t('birth_form_guidance')}
      </div>
      <TagNumberInput edit={true} required={false}/>
      <DamNumberInput edit={true}/>
      <BreedDropdown/>
      <SexDropdown/>
      <AreaDropdown/>
      <div className="form-field">
        <label className="form-field-label">{t('birth_date')}</label>
        <DateInput
          name="_birth_date_picker"
          value={birthDate}
          defaultToToday={false}
          required={false}
          placeholder={t('select_date')}
          onChange={setBirthDate}
        />
        <input type="hidden" name="birth_date" value={birthDate} />
      </div>
      <div className="form-field">
        <label className="form-field-label">{t('registration_date')}</label>
        <DateInput
          name="_registration_date_picker"
          value={registrationDate}
          defaultToToday={false}
          required={true}
          onChange={setRegistrationDate}
        />
        <input type="hidden" name="registration_date" value={registrationDate} />
      </div>

      <button type="button" className="wl-lot-toggle-btn"
        onClick={() => { setShowLotPicker(v => !v); setLotId(''); }}>
        {showLotPicker ? `↩ ${t('use_default_lot')}` : `+ ${t('add_to_specific_lot')}`}
      </button>
      {showLotPicker && (
        <HerdLotDropdown
          selected={lotId}
          onChange={e => setLotId(e.target.value)}
          name="herd_lot_id"
        />
      )}
      {!showLotPicker && <input type="hidden" name="herd_lot_id" value="0" />}
    </>
  );
}

const getBodyFromForm = (formData) => {
  const tag               = formData.get("tag") || "";
  const dam               = formData.get("dam") || "";
  const breed             = formData.get("breed");
  const sex               = formData.get("sex");
  const area              = formData.get("area");
  const birth_date        = formData.get("birth_date");
  const registration_date = formData.get("registration_date");
  const herd_lot_id       = parseInt(formData.get("herd_lot_id") || "0", 10) || 0;
  return JSON.stringify({tag, dam, breed, sex, area, birth_date, registration_date, is_alive: true, is_pregnant: false, death_cause: "", herd_lot_id});
}

export const AddBirth = (props) => {
  const { t } = useTranslation();
  return (
    <DataCollectionAdd
      collection="births"
      getBodyFromForm={getBodyFromForm}
      formElements={AddBirthForm}
      onSuccess={props.onSuccess}
      successMsg={t('animal_added_success')}
      duplicateMsg={t('birth_duplicate_error')}
    />
  );
}

export default AddBirth;
